export default __webpack_public_path__ + "static/media/competenze.fab094d5.png";